export const CLEAR_SELECTED_DEVICE = "V3_CLEAR_SELECTED_DEVICE";
export const GET_DEVICE = "V3_GET_DEVICE";
export const GET_DEVICE_MODELS = "V3_GET_DEVICE_MODELS";
export const GET_DEVICES = "V3_GET_DEVICES";
export const SET_SELECTED_DEVICE = "V3_SET_SELECTED_DEVICE"
export const CREATE_DEVICE = 'V3_CREATE_DEVICE'
export const UPDATE_DEVICE = 'V3_UPDATE_DEVICE'
export const UPDATE_DEVICE_BUZZER_ACTION = 'V3_UPDATE_DEVICE_BUZZER_ACTION'